import React from "react";
import classnames from "classnames";

import currencyFormatter from "@/utils/currencyFormatter";

import OfferLabel from "../OfferLabel";

const ProductCardPrice: React.FC<{
  dealDiscountLabel: string | null;
  displayPrice: number;
  countryCode: string;
  offerLabel: string | null;
  quantityLabel: string | null;
  regularPrice: number | null;
  className?: string;
}> = ({
  countryCode,
  dealDiscountLabel,
  displayPrice,
  quantityLabel,
  offerLabel,
  regularPrice,
  className,
}) => {
  return (
    <div className="text-xs font-bold text-grey">
      starting at
      <div className={classnames("text-sm font-bold text-default", className)}>
        <div className="flex items-center justify-start">
          <div
            className={classnames("font-bold text-lg", {
              "text-notification": dealDiscountLabel,
            })}
            data-testid="menu-item-card__price"
          >
            {`${currencyFormatter(displayPrice, countryCode)}`}
          </div>
          {quantityLabel && (
            <div className="font-bold text-xs pl-xs">{quantityLabel}</div>
          )}
        </div>
        {dealDiscountLabel && (
          <div data-testid="deal-section" className="flex items-center text-xs">
            <div
              data-testid="discount-label"
              className="bg-notification rounded text-white font-bold px-sm"
            >
              {dealDiscountLabel}
            </div>
            <span className="pl-sm text-grey font-normal">{`reg ${currencyFormatter(
              regularPrice,
              countryCode,
            )}`}</span>
          </div>
        )}
        {!dealDiscountLabel && offerLabel && (
          <div data-testid="offer-section" className="whitespace-nowrap">
            <OfferLabel label={offerLabel} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCardPrice;
